"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultApiScope = exports.AUTH_CALLBACK_PATHS = void 0;
exports.AUTH_CALLBACK_PATHS = {
    LEGACY: '/authorize',
    MODERN_KNOWLEDGE_BASE: '/knowledge-base/authorize',
};
const getDefaultApiScope = (clientId) => `${clientId}/.default`;
exports.getDefaultApiScope = getDefaultApiScope;
